// Component for showing dentists near you
//  {/* <ClinicFinder /> */}

import { useState, useEffect } from "react";
import Features from "./UI/Features";
import SolvedProblems from "./UI/SolvedProblems";
import UserValue from "./UI/UserValue";
import Pricing from "./UI/Pricing";
import CTA from "./UI/CTA";
import Footer from "./UI/Footer";
import Header from "./UI/Header";
import LandingNav from "./UI/LandingNav";
import AppShowcase from "./UI/AppShowCase";

const LandingPage = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    // newVisitors();
  }, [window]);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMobileMenuOpen(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-slate-50">
      <LandingNav
        scrollToSection={scrollToSection}
        setMobileMenuOpen={setMobileMenuOpen}
        mobileMenuOpen={mobileMenuOpen}
      />
      <Header scrollToSection={scrollToSection} />
      <AppShowcase />
      {/* Features Section */}
      {/* <Features /> */}
      {/* Problem/Solution Section */}
      <SolvedProblems />
      {/* Real User Value Section */}
      <UserValue />
      {/* Pricing Section */}
      <Pricing />
      {/* CTA Section */}
      <CTA />
      {/* Footer */}
      <Footer scrollToSection={scrollToSection} />
    </div>
  );
};

export default LandingPage;
